import axios from 'http.service';

const baseUrl = '/api/v2/contracts/terms-conditions';

const uploadTermsConditions = async (file, grouping, year, type) => {
	const yearEncoded = encodeURIComponent(year);
	const groupingEncoded = encodeURIComponent(grouping);
	const typeEncoded = encodeURIComponent(type);

	const query = new URLSearchParams();
	query.append('year', yearEncoded);
	query.append('grouping', groupingEncoded);
	query.append('type', typeEncoded);

	const url = `${baseUrl}/update?${query.toString()}`;
	const formData = new FormData();
	formData.append('file', file);
	const config = {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	};
	try {
		const { status } = await axios.post(url, formData, config);
		return status === 201;
	} catch {
		return false;
	}
};

export { uploadTermsConditions };
